import React, { useCallback, useEffect, useRef,useState } from 'react';

import FilePicker from './FilePicker';

import cs from 'clsx';
import s from './SampleSelector.module.css';

function SampleButton({ sample, active, onSelect, onStop, idx }) {
  const click = useCallback(() => {
    onSelect(sample);
  }, [onSelect, sample]);

  return (
    <div>
      <button className={cs(s.sampleButton, active && s.playing)} onClick={active ? onStop : click} />
      <span>Sample {idx}</span>
    </div>
  );
}

export default function SampleSelector({ samples, activeSample, onSelect, onStop, hidden, keepOn }) {
const ref = useRef(true);  
const startMic = useCallback(() => {
    onSelect(0);
    setMic(null);
  }, [onSelect]);

  const filesSubmitted = useCallback(
    (files) => {
      const first = files[0];
      const url = URL.createObjectURL(first);
      const audio = new Audio(url);
      onSelect(audio);
    },
    [onSelect],
  );
  const [mic, setMic] = useState(keepOn);
  
  useEffect(() => {
  //   Update the document title using the browser API
 console.log('keepOn New', mic);  
 if(mic){
   console.log('keepOn', mic);
   ref.current.click();
}
  },[mic]);
  return (
    <div className={cs(s.base, hidden && s.hidden)}>
      <button className={cs(s.dictateAudio)} ref={ref} onClick={startMic}>
        Automated Note Taking
      </button>
      <FilePicker onSubmit={filesSubmitted} />
      <div className={s.presets}>
        {Object.keys(samples).map((s, i) => (
          <SampleButton
            idx={i + 1}
            key={i}
            sample={samples[s]}
            active={activeSample === samples[s]}
            onSelect={onSelect}
            onStop={onStop}
          />
        ))}
      </div>
      <div className={s.credit}>
        <small>
          Note: Samples were synthesized using data from <a href='https://www.mtsamples.com'>MTSamples.com</a>
        </small>
      </div>
    </div>
  );
}
